module.exports = __webpack_public_path__ + "static/media/S3N13-3.6a6a391e.svg";